import { COMPANIES } from "constants/action-types";
import { stringify } from "querystring";
import type { LoadWorkingOrderAction } from "./working-order-state";

export interface IFetchCompaniesMeta {
    loadCart?: LoadWorkingOrderAction["payload"];
}

export const fetchCompanies = (query: Record<string, any>, meta?: IFetchCompaniesMeta) => ({
    type: COMPANIES.FETCH.START,
    payload: { url: `/api/v3.0/companies?${stringify({ __fields: ["__all"], __translate: false, ...query })}` },
    meta: { ...meta, query },
});

export const fetchCompaniesById = (ids: string[], meta?: IFetchCompaniesMeta) => fetchCompanies({ _id: ids }, meta);
